export default __webpack_public_path__ + "static/media/logo.f585fa7c.png";